export default __webpack_public_path__ + "static/media/scrum.9d47dc76.png";